import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import AvTimerIcon from '@material-ui/icons/AvTimer';

export const GirIcon = AccountBalanceIcon;
export const GirToRegisterIcon = AvTimerIcon;
export const GirDisabledIcon = AccountBalanceIcon;